export const decimalFormattingV1 = {
  namespaced: true,
  state: {
    decimalFormatReference: [
      {
        Name: "Decimal-TransactionNo",
        Width: 120,
        Code: 0,
        Format: "###########",
      },
      {
        Name: "Decimal-9-0",
        Width: 120,
        Code: 1,
        Format: "###,###,##0",
      },
      { Name: "Decimal-6-2", Width: 120, Code: 2, Format: "###,##0.00" },
      {
        Name: "Decimal-6-4",
        Width: 120,
        Code: 3,
        Format: "###,##0.0000",
      },
      { Name: "Decimal-4-0", Width: 120, Code: 4, Format: "###0" },
      { Name: "Decimal-3-2", Width: 120, Code: 5, Format: "##0.00" },
      {
        Name: "Decimal-3-2P",
        Width: 120,
        Code: 6,
        Format: "##0.00 '%'",
      },
      { Name: "Decimal-4-2", Width: 120, Code: 7, Format: "#,##0.00" },
      {
        Name: "Decimal-4-2P",
        Width: 120,
        Code: 8,
        Format: "#,##0.00 '%'",
      },
      { Name: "Decimal-4-4", Width: 120, Code: 9, Format: "#,##0.0000" },
      { Name: "Decimal-2-0", Width: 120, Code: 10, Format: "#0" },
      {
        Name: "Decimal-6-2C",
        Width: 120,
        Code: 11,
        Format: "$ ###,##0.00",
      },
      {
        Name: "Decimal-4-2C",
        Width: 120,
        Code: 12,
        Format: "$ #,##0.00",
      },
      {
        Name: "Decimal-4-4C",
        Width: 180,
        Code: 13,
        Format: "$ #,##0.0000",
      },
      {
        Name: "Decimal-6-0C",
        Width: 120,
        Code: 14,
        Format: "$ ###,##0",
      },
      {
        Name: "Decimal-6-0",
        Width: 120,
        Code: 15,
        Format: "###,##0",
      },
      {
        Name: "Decimal-8-2C",
        Width: 150,
        Code: 16,
        Format: "$ ##,###,##0.00",
      },
      {
        Name: "Decimal-4-2C-RO",
        Width: 120,
        Code: 17,
        Format: "$ #,##0.00;($ #,##0.00)",
      },
      {
        Name: "Decimal-4-2-RO",
        Width: 120,
        Code: 18,
        Format: "#,##0.00;(#,##0.00)",
      },
      {
        Name: "Decimal-8-2C-RO",
        Width: 150,
        Code: 19,
        Format: "$ ##,###,##0.00;($ ##,###,##0.00)",
      },
    ],
  },
  actions: {},
  mutations: {},
  getters: {
    getDecimalFormats(state) {
      return state.decimalFormatReference;
    },
    getDecimalFormatByCode: (state) => (Code) => {
      return state.decimalFormatReference.find((i) => i.Code == Code);
    },
    getDecimalFormatByName: (state) => (Name) => {
      return state.decimalFormatReference.find((i) => i.Name == Name);
    },
  },
};
